// Generated by Melange

import * as Buhta_components__CountryIcon from "../../../../../../packages/components/src/atoms/CountryIcon.js";
import * as Buhta_core__Toast from "../../../../../../packages/core/lib/Toast.js";
import * as Buhta_landing__Api from "../../../core/Api.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__Field from "../../../components/landing/Field.js";
import * as Buhta_landing__FooterUtils from "./FooterUtils.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Cms from "../../../../../../packages/models/Cms.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function FooterFormMobile(Props) {
  const match = React.useState(function () {
    return "";
  });
  const setCompany = match[1];
  const company = match[0];
  const match$1 = React.useState(function () {
    return "";
  });
  const setEmail = match$1[1];
  const email = match$1[0];
  const match$2 = React.useState(function () {
    return "";
  });
  const setPhone = match$2[1];
  const phone = match$2[0];
  const match$3 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$3[1];
  const match$4 = React.useState(function () {
    return true;
  });
  const setPhoneValid = match$4[1];
  const match$5 = React.useState(function () {
    return false;
  });
  const setLoading = match$5[1];
  const loading = match$5[0];
  const country = Buhta_landing__Route.getCountry(undefined);
  const prefix = Buhta_models__Locale.getPhonePrefix(country);
  const intl = ReactIntl.useIntl();
  const phoneInputRef = React.useRef(null);
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsx(Buhta_landing__Field.make, {
        label: Buhta_landing__I18n.trans(intl, "company_name"),
        type_: "text",
        name: "company",
        value: company,
        onChange: (function (value) {
          Curry._1(setCompany, (function (param) {
            return value;
          }));
        }),
        className: "h-14 border border-divider rounded-tr-lg rounded-tl-lg p-4",
        required: true,
        disabled: loading
      }),
      JsxRuntime.jsx(Buhta_landing__Field.make, {
        label: "Email",
        type_: "email",
        name: "email",
        value: email,
        onChange: (function (value) {
          Curry._1(setEmail, (function (param) {
            return value;
          }));
        }),
        className: "h-14 border-l border-r border-divider p-4",
        required: true,
        disabled: loading
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__CountryIcon.make, {
            country: country
          }),
          JsxRuntime.jsx("span", {
            children: prefix,
            className: "paragraph-medium text-black-landing ml-3"
          }),
          JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/dropdown-arrow.svg")
          }),
          JsxRuntime.jsx("input", {
            ref: phoneInputRef,
            className: Cn.fromList({
              hd: "paragraph bg-bg input-invalid",
              tl: {
                hd: match$4[0] ? "text-black-landing" : "text-alert",
                tl: /* [] */ 0
              }
            }),
            disabled: loading,
            name: "phone",
            type: "text",
            value: phone,
            onChange: (function (ev) {
              const value = ev.target.value;
              Curry._1(setPhone, (function (param) {
                return value;
              }));
              Curry._1(setPhoneValid, (function (param) {
                return Buhta_landing__FooterUtils.checkPhoneValid(phoneInputRef, country);
              }));
            })
          })
        ],
        className: "border border-divider rounded-br-lg rounded-bl-lg flex items-center p-4 h-14",
        onClick: (function (param) {
          Buhta_landing__EventHandlers.focusInput(phoneInputRef);
        })
      }),
      JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
        classes: {
          hd: "w-full mt-4",
          tl: /* [] */ 0
        },
        label: Buhta_landing__I18n.trans(intl, "send_request"),
        type_: "submit",
        isDisabled: loading
      })
    ],
    className: "mt-6",
    onSubmit: (function (ev) {
      const payload = {
        company: company,
        email: email,
        phone: phone,
        prefix: prefix,
        serviceType: "",
        name: "",
        bin: "",
        question: ""
      };
      ev.preventDefault();
      Curry._1(setLoading, (function (param) {
        return true;
      }));
      ev.preventDefault();
      const __x = Buhta_landing__Api.submitRequest(Buhta_models__Cms.$$Request.encode(payload));
      $$Promise.get(__x, (function (res) {
        if (res.TAG === /* Ok */ 0) {
          Curry._1(dispatchToasts, {
            TAG: /* Add */ 0,
            _0: {
              id: Buhta_core__Toast.generateId(undefined),
              text: "Заявка успешно доставлена",
              kind: "success",
              onClick: (function (param) {
                
              })
            }
          });
          Curry._1(setCompany, (function (param) {
            return "";
          }));
          Curry._1(setEmail, (function (param) {
            return "";
          }));
          Curry._1(setPhone, (function (param) {
            return "";
          }));
        } else {
          Curry._1(dispatchToasts, {
            TAG: /* Add */ 0,
            _0: {
              id: Buhta_core__Toast.generateId(undefined),
              text: "Произошла ошибка. Попробуйте еще раз.",
              kind: "warning",
              onClick: (function (param) {
                
              })
            }
          });
        }
        Curry._1(setLoading, (function (param) {
          return false;
        }));
      }));
    })
  });
}

const make = FooterFormMobile;

export {
  make,
}
/* Buhta_components__CountryIcon Not a pure module */
